import React from 'react';
import { motion } from 'framer-motion';

const TermsPage = () => {
  return (
    <div className="min-h-screen py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="font-serif text-4xl md:text-5xl mb-8">Terms of Service</h1>
          
          <div className="prose prose-lg max-w-none text-gray-700">
            <p className="text-lg text-gray-600 mb-8">
              Last updated: {new Date().toLocaleDateString('en-GB', { month: 'long', year: 'numeric' })}
            </p>

            <section className="mb-8">
              <h2 className="font-serif text-2xl mb-4">1. Introduction</h2>
              <p>
                Welcome to The Gem Atelier. These Terms of Service ("Terms") govern your use of our website and the purchase of gemstones and related products from our online boutique. By accessing our website or making a purchase, you agree to be bound by these Terms.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-2xl mb-4">2. Products and Descriptions</h2>
              <p className="mb-4">
                We take great care to accurately describe and photograph our gemstones. However, please note:
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Colours may vary slightly due to monitor settings and lighting conditions</li>
                <li>Natural gemstones may have unique characteristics, inclusions, and variations that make each stone one-of-a-kind</li>
                <li>All weights, measurements, and specifications are approximate unless otherwise stated</li>
                <li>Certification details are provided where applicable and available</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-2xl mb-4">3. Pricing and Payment</h2>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>All prices are displayed in the currency indicated and are subject to change without notice</li>
                <li>Payment must be received in full before orders are dispatched</li>
                <li>We accept major credit cards and other payment methods as displayed at checkout</li>
                <li>All transactions are processed securely through our payment provider</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-2xl mb-4">4. Orders and Availability</h2>
              <p className="mb-4">
                Due to the unique nature of our gemstones:
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Each gemstone is one-of-a-kind and subject to availability</li>
                <li>Items may be reserved during the checkout process for a limited time</li>
                <li>We reserve the right to cancel orders if a gemstone becomes unavailable</li>
                <li>Order confirmation will be sent via email once your purchase is complete</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-2xl mb-4">5. Shipping and Delivery</h2>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>We ship worldwide using secure, insured courier services</li>
                <li>Delivery times vary depending on destination and shipping method selected</li>
                <li>Risk of loss transfers to you upon delivery to the carrier</li>
                <li>You are responsible for any customs duties or import taxes applicable in your country</li>
                <li>Signature may be required upon delivery for high-value items</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-2xl mb-4">6. Returns and Refunds</h2>
              <p className="mb-4">
                We want you to be completely satisfied with your purchase:
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Returns are accepted within 14 days of delivery for unused items in original condition</li>
                <li>Items must be returned in their original packaging with all certificates and documentation</li>
                <li>Custom or bespoke orders may not be eligible for return</li>
                <li>Return shipping costs are the responsibility of the buyer unless the item is faulty or not as described</li>
                <li>Refunds will be processed within 7-10 business days of receiving the returned item</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-2xl mb-4">7. Intellectual Property</h2>
              <p>
                All content on this website, including text, images, logos, and design elements, is the property of The Gem Atelier and is protected by copyright and intellectual property laws. You may not reproduce, distribute, or use any content without our prior written consent.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-2xl mb-4">8. User Accounts</h2>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>You are responsible for maintaining the confidentiality of your account credentials</li>
                <li>You agree to provide accurate and complete information when creating an account</li>
                <li>We reserve the right to suspend or terminate accounts that violate these Terms</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-2xl mb-4">9. Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by law, The Gem Atelier shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of our website or purchase of our products. Our total liability shall not exceed the amount paid for the specific product giving rise to the claim.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-2xl mb-4">10. Governing Law</h2>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of the United Kingdom. Any disputes arising from these Terms or your use of our website shall be subject to the exclusive jurisdiction of the courts of England and Wales.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-2xl mb-4">11. Changes to Terms</h2>
              <p>
                We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting to our website. Your continued use of our website after any changes constitutes acceptance of the modified Terms.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-2xl mb-4">12. Contact</h2>
              <p>
                If you have any questions about these Terms, please contact us through our website's messaging system or visit our Contact page.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsPage;
